import { components } from "./components";
import { dataSource } from "./datasource";
import { fields } from "./fields";
import { filterType } from "./filtertype";
import { pagingType } from "./pagingtype";
import { props } from "./props";
import { securityData } from "./securitydata";
import { template } from "./template";

export const coreStoreFeatures =
{
    components,
    dataSource,
    fields,
    filterType,
    pagingType,
    props,
    securityData,
    template
};